import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from '../components/CTAButtons';
import { MessageCircleIcon, SendIcon, MailIcon, ClockIcon, LockIcon } from 'lucide-react';
export const Contact: React.FC = () => {
  const fadeIn = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  return <div className="bg-white" data-id="element-222">
      {/* Hero Section */}
      <section className="bg-black text-white py-16 md:py-24" data-id="element-223">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-224">
          <motion.div className="max-w-3xl mx-auto text-center" initial="hidden" animate="visible" variants={fadeIn} data-id="element-225">
            <h1 className="text-4xl md:text-5xl font-bold tracking-tight mb-6" data-id="element-226">
              Contact Us
            </h1>
            <p className="text-xl text-gray-300" data-id="element-227">
              Reach out for a confidential discussion about your business
              situation.
            </p>
          </motion.div>
        </div>
      </section>
      {/* Contact Methods */}
      <section className="py-16 md:py-24 bg-white" data-id="element-228">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-229">
          <motion.div className="max-w-3xl mx-auto" initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-100px'
        }} variants={fadeIn} data-id="element-230">
            <div className="text-center mb-12" data-id="element-231">
              <h2 className="text-3xl font-bold mb-4" data-id="element-232">Get in Touch</h2>
              <p className="text-lg text-gray-600" data-id="element-233">
                We prioritise direct communication for sensitive business
                matters. Choose your preferred method to contact us.
              </p>
            </div>
            <div className="grid md:grid-cols-3 gap-8" data-id="element-234">
              <div className="bg-gray-50 p-8 rounded-lg text-center" data-id="element-235">
                <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-236">
                  <MessageCircleIcon className="h-8 w-8 text-white" data-id="element-237" />
                </div>
                <h3 className="text-xl font-bold mb-4" data-id="element-238">WhatsApp</h3>
                <p className="text-gray-600 mb-6" data-id="element-239">
                  Quick responses during business hours. Secure and
                  confidential.
                </p>
                <CTAButton type="whatsapp" text="Message on WhatsApp" className="w-full" onClick={() => window.open('https://wa.me/YOURPHONENUMBER', '_blank')} data-id="element-240" />
              </div>
              <div className="bg-gray-50 p-8 rounded-lg text-center" data-id="element-241">
                <div className="w-16 h-16 bg-blue-500 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-242">
                  <SendIcon className="h-8 w-8 text-white" data-id="element-243" />
                </div>
                <h3 className="text-xl font-bold mb-4" data-id="element-244">Telegram</h3>
                <p className="text-gray-600 mb-6" data-id="element-245">
                  Enhanced encryption for maximum privacy. Available 7 days a
                  week.
                </p>
                <CTAButton type="telegram" text="Message on Telegram" className="w-full" onClick={() => window.open('https://t.me/YOURUSERNAME', '_blank')} data-id="element-246" />
              </div>
              <div className="bg-gray-50 p-8 rounded-lg text-center" data-id="element-247">
                <div className="w-16 h-16 bg-gray-700 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-248">
                  <MailIcon className="h-8 w-8 text-white" data-id="element-249" />
                </div>
                <h3 className="text-xl font-bold mb-4" data-id="element-250">Email</h3>
                <p className="text-gray-600 mb-6" data-id="element-251">
                  For detailed inquiries. We aim to respond within 24 hours.
                </p>
                <div className="space-y-3" data-id="element-252">
                  <CTAButton type="email" text="Send Email" className="w-full" onClick={() => window.location.href = 'mailto:info@debtrescue.it.com'} data-id="element-253" />
                  <p className="text-sm text-gray-600 text-center" data-id="element-254">
                    info@debtrescue.it.com
                  </p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
      {/* Office Information */}
      <section className="py-12 md:py-16 bg-gray-50" data-id="element-255">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-256">
          <motion.div className="max-w-3xl mx-auto" initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-100px'
        }} variants={fadeIn} data-id="element-257">
            <div className="bg-white p-8 rounded-lg shadow-sm" data-id="element-258">
              <h3 className="text-xl font-bold mb-4" data-id="element-259">Business Information</h3>
              <div className="space-y-4" data-id="element-260">
                <div className="flex items-start" data-id="element-261">
                  <div className="mr-3 mt-1" data-id="element-262">
                    <ClockIcon className="h-5 w-5 text-red-600" data-id="element-263" />
                  </div>
                  <div data-id="element-264">
                    <h4 className="font-bold" data-id="element-265">Business Hours:</h4>
                    <p className="text-gray-600" data-id="element-266">
                      Monday to Friday: 9:00 AM - 5:00 PM
                    </p>
                    <p className="text-gray-600" data-id="element-267">
                      Weekend: By appointment only
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
      {/* Confidentiality Notice */}
      <section className="py-12 md:py-16 bg-white" data-id="element-268">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-269">
          <motion.div className="max-w-3xl mx-auto" initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-100px'
        }} variants={fadeIn} data-id="element-270">
            <div className="bg-gray-50 p-8 rounded-lg border border-gray-200" data-id="element-271">
              <h3 className="text-xl font-bold mb-4" data-id="element-272">
                Confidentiality Guarantee
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-273">
                We understand the sensitive nature of business debt issues. All
                communications with Debt Rescue are:
              </p>
              <ul className="space-y-2 text-gray-700" data-id="element-274">
                <li className="flex items-center" data-id="element-275">
                  <MailIcon className="h-5 w-5 text-red-600 mr-2" data-id="element-276" />
                  <a href="mailto:info@debtrescue.it.com" className="hover:underline" data-id="element-277">
                    info@debtrescue.it.com
                  </a>
                </li>
                <li className="flex items-center" data-id="element-278">
                  <LockIcon className="h-5 w-5 text-red-600 mr-2" data-id="element-279" />
                  <span data-id="element-280">Completely confidential</span>
                </li>
                <li className="flex items-center" data-id="element-281">
                  <LockIcon className="h-5 w-5 text-red-600 mr-2" data-id="element-282" />
                  <span data-id="element-283">No information shared without consent</span>
                </li>
                <li className="flex items-center" data-id="element-284">
                  <LockIcon className="h-5 w-5 text-red-600 mr-2" data-id="element-285" />
                  <span data-id="element-286">Secure handling of all documents</span>
                </li>
              </ul>
            </div>
          </motion.div>
        </div>
      </section>
    </div>;
};